import styled from 'styled-components';

export const DropdownMLStyled = styled.div`
  button {
    background-color: ${(props) => {
      return props.theme[props.brand].btn.bgColor;
    }};
    color: ${(props) => props.theme[props.brand].btn.color} !important;
    font-size: ${(props) => props.fontsize} !important;
    width: ${(props) => props.width} !important;
    height: ${(props) => props.height} !important;
    padding: 6px 20px !important;
    border: none;
  }
  button:hover {
    border: none;
    box-shadow: 1px 1px 5px ${(props) => props.theme[props.brand].btn.bgColor} !important;
  }
  .ant-btn:hover,
  .ant-btn:focus,
  .ant-btn:active,
  .ant-btn.active {
    background: ${(props) => props.theme[props.brand].btn.hoverColor};
    border-color: ${(props) => props.theme[props.brand].btn.bgColor};
  }
  button:hover {
    border: none;
  }
  .ant-btn-lg {
    border-radius: 0;
  }
  .ant-btn-round.ant-btn-lg {
    border-radius: 0;
  }
  .ant-btn[disabled] {
    background-color: ${(props) => {
      return props.theme[props.brand].btn.bgColor;
    }};
  }
`;
